import React from 'react';
import AdminPanel from '../components/admin/AdminPanel';

const Admin = ({ siteData, setSiteData, updateSiteData }) => {
    return (
        <AdminPanel
            siteData={siteData}
            setSiteData={setSiteData}
            updateSiteData={updateSiteData}
        />
    );
};

export default Admin;